module.exports = __webpack_public_path__ + "images/bf-background-desktop.jpg";